<div class="product-box" [class]="{'product-box-height': type() === 'else'}">
    @if (box().type == 'video') {
        <video autoplay muted loop>
            <source [src]="box().src">

        </video>

    }  @else {
        <img [src]="box().src">
    }


    <p class="product-box-text">{{box().title}}</p>

</div>
